// Markdown renderer for pack content (blurb, voice_note, prompts, hints).
// Content is author-controlled but we still sanitise via DOMPurify defence-in-depth.

import { useMemo } from 'react'
import { marked } from 'marked'
import DOMPurify from 'dompurify'

marked.setOptions({ gfm: true, breaks: false })

interface Props {
  children: string
  className?: string
  inline?: boolean
}

export function Markdown({ children, className, inline = false }: Props) {
  const html = useMemo(() => {
    const raw = inline ? marked.parseInline(children ?? '') : marked.parse(children ?? '')
    const str = typeof raw === 'string' ? raw : ''
    // DOMPurify sanitises output to prevent XSS even though pack content is author-controlled.
    return DOMPurify.sanitize(str)
  }, [children, inline])

  const Tag = inline ? 'span' : 'div'
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: html }} />
}

export default Markdown
